import gql from 'graphql-tag'

export const COUNT_CAMPAINGS = gql` 
query Campaigns($startDatetime: Int!, $endDatetime: Int!, $teamId: Int!, $filter: String) {
  count_campaigns_business(team_id: $teamId, start_datetime: $startDatetime, end_datetime: $endDatetime, filter: $filter
  ) {
  count
}
}`